import PropTypes from 'prop-types';

function getContentType(url) {
  if (url.includes('youtu')) return 'youtube';

  return 'image';
}

function getVideoId(url) {
  const matches = /(youtu.*be.*)\/(watch\?v=|embed\/|v|shorts|)(.*?((?=[&#?])|$))/gm.exec(url);
  if (!matches) return null;
  return matches[3];
}

const GalleryItem = ({
  border,
  children,
  className,
  description,
  isPreview,
  onClick,
  size,
  url,
}) => {
  const contentType = url ? getContentType(url) : null;

  const content = (
    <>
      {contentType === 'image' && (
        <img src={url} alt={description} className="w-full h-full object-contain pt-4" />
      )}
      {contentType === 'youtube' && !isPreview && (
        <iframe
          title={`youtube-video-${url}`}
          className="w-full h-full"
          src={`https://www.youtube.com/embed/${getVideoId(url)}`}
        />
      )}
      {contentType === 'youtube' && isPreview && (
        <img
          src={`https://img.youtube.com/vi/${getVideoId(url)}/default.jpg`}
          alt="Youtube video"
          className="w-full h-full object-contain"
        />
      )}
    </>
  );

  return (
    <button
      type="button"
      className={`
        rounded
        overflow-hidden
        ${className}
        ${border === 'normal' ? 'border border-gray-400' : ''}
        ${border === 'active' ? 'border-2 border-primary' : ''}
        ${size === 'small' ? 'w-16 h-16' : ''}
        ${size === 'medium' ? 'w-32 h-32' : ''}
        ${size === 'full' ? 'w-full h-full' : ''}
      `}
      onClick={onClick}
    >
      {url ? content : children}
    </button>
  );
};

GalleryItem.propTypes = {
  border: PropTypes.oneOf(['active', 'none', 'normal']),
  children: PropTypes.node,
  className: PropTypes.string,
  description: PropTypes.string,
  onClick: PropTypes.func,
  isPreview: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'full']),
  url: PropTypes.string,
};

GalleryItem.defaultProps = {
  border: 'normal',
  children: null,
  className: '',
  description: null,
  onClick: () => {},
  isPreview: false,
  size: 'small',
  url: null,
};

export default GalleryItem;
